export const roundToSixDecimalPlaces = (number) => Number(Number(number).toFixed(6))
